import React, { useEffect, useState } from 'react';
import '../../../../scss/pages/Attendance/Component/WeeklyOff/weeklyOff.scss';
import LeftArrow from '../../../../asset/svg/leftArrow.svg';
import { ADMIN_PATH } from '../../../../utils/Constants';
import { useNavigate } from 'react-router';
import { FormControl, InputAdornment, TextField, Typography, } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import { GET_WEEKOFF_SUBORDINATE_DATA, POST_WEEKOFF_SUBORDINATE_DATA } from '../../../../sagas/type';
import { getLocalStoreString } from '../../../../utils/Helper';
import weeklyOffEmptyIcon from '../../../../asset/svg/weeklyOffEmptyIcon.svg'
import { useSnackbar } from 'notistack';

function WeeklyOff() {
    const EmployeeCode = getLocalStoreString("EmployeeCode");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { WeekoffSubordinateData } = useSelector(mapStateToProps);
    const [searchName, setSearchName] = useState('');
    const [expanded, setExpanded] = useState(false);
    const [weekDays, setWeekDays] = useState(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']);
    const [focusedEmployee, setFocusedEmployee] = useState(null)
    const [weekOffDates, setWeekOffDates] = useState("")

    const handleChange = (data, index) => (event, isExpanded) => {
        setFocusedEmployee(data)
        setWeekOffDates(data.configValue)
        setExpanded(isExpanded ? index : false);
    };

    const handleSearch = (event) => {
        const { value } = event.target
        setSearchName(value)
    }

    const handleBack = () => {
        navigate(ADMIN_PATH)
    }

    const getSubordinateData = () => {
        dispatch({
            type: GET_WEEKOFF_SUBORDINATE_DATA,
            payload: { EmployeeCode },
        });
    }

    useEffect(() => {
        getSubordinateData()
    }, [])

    const handleWeekDaysClick = (days) => {
        const tempFocusedEmployee = { ...focusedEmployee };
        const configValue = focusedEmployee?.configValue ? [...new Set(tempFocusedEmployee?.configValue?.split(','))] : []
        if (configValue.includes(days)) {
            configValue.splice(configValue.indexOf(days), 1)
        } else {
            configValue.push(days)
        }
        setFocusedEmployee({ ...tempFocusedEmployee, configValue: configValue.join(',') })
    }

    const handleSave = () => {
        const postWeekDays = [{ employeeCode: focusedEmployee?.employeeCode, configValue: focusedEmployee?.configValue }]
        dispatch({
            type: POST_WEEKOFF_SUBORDINATE_DATA,
            payload: postWeekDays,
            getSubordinateData: getSubordinateData,
            enqueueSnackbar: enqueueSnackbar,
            setExpanded: setExpanded,
        });
    }
    const validateForm = () => {
        let isValid = false
        if (focusedEmployee) {
            const { configValue } = focusedEmployee;
            const selectedDates = configValue.split(",");
            const prevWeekOffDates = weekOffDates && typeof weekOffDates === "string" ? weekOffDates.split(",") : [];
            if (!(prevWeekOffDates.length === 0 && !configValue)) {
                if (selectedDates.length !== prevWeekOffDates.length) isValid = true;
                for (const selectedDate of selectedDates) {
                    if (!prevWeekOffDates.includes(selectedDate)) isValid = true
                };
            }
        }
        return isValid;
    };
    return (
        <div className='WeeklyOff-Container'>
            <div className='WeeklyOff-Container_header'>
                <div>
                    {/* <img className='WeeklyOff-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp; */}
                    <span className='WeeklyOff-Container_header_content'>Weekly Off</span>
                </div>
            </div>
            <div className='WeeklyOff-Container_searchcontainer'>
                <FormControl sx={{ m: 1, width: `${searchName.length > 0 ? '220px' : '270px'}`, backgroundColor: 'rgba(255,255,255,0.18)', borderRadius: '12px', padding: 1 }}>
                    <TextField size="small" type='search' variant="outlined" placeholder='Search' onChange={handleSearch} value={searchName}
                        InputProps={{ startAdornment: (<InputAdornment position='start'>{searchName.length == 0 && <SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.30)' }} />}</InputAdornment>), }} />
                </FormControl>
                {searchName.length > 0 && <span onClick={() => setSearchName('')} className='WeeklyOff-Container_searchcontainer_content'>Cancel</span>}
            </div>
            <div className='WeeklyOff-Container_listHeading'>
                <Typography>Employee</Typography>
                <Typography>Week Off</Typography>
            </div>
            {WeekoffSubordinateData && WeekoffSubordinateData.length > 0 ? WeekoffSubordinateData.filter((element) => element.employeeName?.toLowerCase().includes(searchName?.toLowerCase())).map((data, index) => {
                return (
                    <div className='WeeklyOff-Container_listData'>
                        <Accordion expanded={expanded === index} sx={{ borderBottomLeftRadius: expanded === index ? 'none' : '10px', borderBottomRightRadius: expanded === index ? 'none' : 'inherit', }} onChange={handleChange(data, index)}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#8074FF' }} />} aria-controls="panel2bh-content" id="panel2bh-header" >
                                <div className='WeeklyOff-Container_listData_listDataContainer' >
                                    <Typography sx={{ color: 'rgba(255,255,255,1)', fontWeight: 600, fontSize: '12px', lineHeight: '12px' }}>{data.employeeName && data.employeeName.length > 12 ? data.employeeName.substring(0, 12) + "..." : data.employeeName}</Typography>
                                    <Typography sx={{ color: 'rgba(255,255,255,0.40)', fontWeight: 400, fontSize: '12px', lineHeight: '12px' }}>{data.employeeCode ? data.employeeCode : '-'} </Typography>
                                </div>
                                {data?.configValue.length > 0 ? <div className='WeeklyOff-Container_listData_daysViewContainer'>
                                    {weekDays && weekDays?.length > 0 && weekDays.filter((days) => data.configValue.split(',').includes(days)).map((day) => {
                                        return (
                                            <div className={data?.configValue.split(',').includes(day) ? 'WeeklyOff-Container_listData_daysViewContainer_daysViewWithData' : 'WeeklyOff-Container_listData_daysViewContainer_daysViewWithOutData'} key={day}>{day}</div>)
                                    })}
                                </div> : <Typography sx={{ color: '#FFF', fontWeight: 500, fontSize: '10px', lineHeight: '10px', textAlign: 'center' }}>No Weekly Off</Typography>}
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='WeeklyOff-Container_listData_userDatas'>
                                    <div className='WeeklyOff-Container_listData_userDatas_position'>
                                        <Typography sx={{ display: "inline", fontStyle: 'normal', fontWeight: '400', fontSize: '14px', lineHeight: '17px', color: 'rgba(255,255,255,0.5)', padding: '10px' }} component="span" variant="body2" color="white"> Department</Typography>
                                        <Typography sx={{ color: 'white', fontStyle: 'normal', fontWeight: '600', fontSize: '14px', lineHeight: '17px', padding: '10px' }}>{data?.department ? data?.department : '-'}</Typography>
                                    </div>
                                    <div className='WeeklyOff-Container_listData_userDatas_position'>
                                        <Typography sx={{ display: "inline", fontStyle: 'normal', fontWeight: '400', fontSize: '14px', lineHeight: '17px', color: 'rgba(255,255,255,0.5)', padding: '10px' }} component="span" variant="body2" color="white">Designation</Typography>
                                        <Typography sx={{ color: 'white', fontStyle: 'normal', fontWeight: '600', fontSize: '14px', lineHeight: '17px', padding: '10px' }}>{data?.designation ? data?.designation : '-'}</Typography>
                                    </div>
                                    <div className='WeeklyOff-Container_listData_userDatas_position'>
                                        <Typography sx={{ display: "inline", fontStyle: 'normal', fontWeight: '400', fontSize: '14px', lineHeight: '17px', color: 'rgba(255,255,255,0.5)', padding: '10px' }} component="span" variant="body2" color="white">Reporting Manager</Typography>
                                        <Typography sx={{ color: 'white', fontStyle: 'normal', fontWeight: '600', fontSize: '14px', lineHeight: '17px', padding: '10px' }}>{data?.reportingManager ? data?.reportingManager : '-'}</Typography>
                                    </div>
                                    <div className='WeeklyOff-Container_listData_userDatas_position'>
                                        <Typography sx={{ display: "inline", fontStyle: 'normal', fontWeight: '400', fontSize: '14px', lineHeight: '17px', color: 'rgba(255,255,255,0.5)', padding: '10px' }} component="span" variant="body2" color="white">Store Name</Typography>
                                        <Typography sx={{ color: 'white', fontStyle: 'normal', fontWeight: '600', fontSize: '14px', lineHeight: '17px', padding: '10px' }}>{data?.storeName ? data?.storeName : '-'}</Typography>
                                    </div>
                                </div>
                                <div className='WeeklyOff-Container_listData_userWeekOff' >
                                    {weekDays?.map((days) => <button className={[...new Set(focusedEmployee?.configValue?.split(','))].includes(days) ? 'WeeklyOff-Container_listData_userWeekOff_userWeekOffWithDay' : 'WeeklyOff-Container_listData_userWeekOff_userWeekOffWithOutDay'} key={days} onClick={() => handleWeekDaysClick(days)}>{days}</button>)}
                                </div>
                                <div className='WeeklyOff-Container_listData_buttonContainer'>
                                    <button type='submit' disabled={!validateForm()} className='WeeklyOff-Container_listData_buttonContainer_active-button' onClick={handleSave}>Save</button>
                                </div>
                            </AccordionDetails>

                        </Accordion>
                    </div>
                )
            }) :
                <div className='WeeklyOff-Container_EmptyIconContainer' >
                    <div className='WeeklyOff-Container_EmptyIconContainer_ImageContainer' >
                        <img className='WeeklyOff-Container_EmptyIconContainer_ImageContainer_Image' src={weeklyOffEmptyIcon} alt="" />
                    </div>
                    <div className='WeeklyOff-Container_EmptyIconContainer_ContentContainer'>
                        <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='rgba(255,255,255,0.8)' >No Employee Found</Typography>
                    </div>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        WeekoffSubordinateData: state.attendanceConfig.WeekoffSubordinateData,
    }
}

export default WeeklyOff;